import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';
import Input from '../form/input';
import CategoryTree from './tree';
import CategoryNav from './nav';

import util from '../../lib/util';
import style from './style.css';

@observer
class CategoryTableLine extends Component {
    updateLineField = (e) => {
        // console.log('updateLineField:', e);
        const { updateField } = this.props;
        const { params } = e.target.dataset;
        const inputParams = JSON.parse(params || {});
        const { id, field } = inputParams;
        const { value } = e.target;
        updateField(id, field, value);
    }

    saveLineField = (e) => {
        // console.log('saveField:', e);
        const { saveField } = this.props;
        const { params } = e.target.dataset;
        const inputParams = JSON.parse(params || {});
        const {
            id, field, updatememory, value,
        } = inputParams;
        saveField(id, field, value, updatememory);
    }

    render() {
        const { category, saved } = this.props;
        return (
            <tr class={`${style.tableline}`}>
                <td>
                    {category.groupno}
                </td>
                <td>
                    <a href={`/categories/${category.groupno}/Basics`}>{category.name}</a>
                    {category.discount && <span class='ml-2 font-weight-lighter'>(-{category.discount}%)</span>}
                    <small class='float-right'>
                        {category.hasNewProducts && <span class={`ml-2 badge badge-pill badge-info`}>
                            <i class='fas fa-star-of-life' /> Has new products
                        </span>}
                        {category.hasPresaleProducts && <span class={`ml-2 badge badge-pill badge-warning`}>
                            <i class='fas fa-redo' /> Has PS products
                        </span>}
                    </small>
                    <div class='small'>
                        <div>
                            {category.articles && category.articles.map(art => (
                                <span class='mr-2 badge badge-primary'><i class='fas fa-newspaper' /> {art.id}: {art.title}</span>
                            ))}
                        </div>
                        <div>
                            {category.categories && category.categories.map(cat => (
                                <span class='mr-2 badge badge-info'><i class='fas fa-folder-open' /> {cat.text}</span>
                            ))}
                        </div>
                        <div>
                            {category.products && category.products.map(prod => (
                                <span class='mr-2 badge badge-secondary'><i class='fas fa-tshirt' /> {prod.name}</span>
                            ))}
                        </div>
                        {JSON.stringify(category.imgs)}
                        {JSON.stringify(category.images)}
                    </div>
                </td>
                <td>
                    {category.level}
                </td>
                <td>
                    {category.parent}
                </td>
                <td>
                    <small>
                        <span
                            class={`mr-1 badge ${style.pointerCursor} badge-${category.status === 2 ? 'success' : 'danger'}`}
                            // onClick={() => categoryStore.saveField(category.id, `status`, category.status === 1 ? 2 : 1, true)}
                            data-params={JSON.stringify({
                                id: category.id,
                                field: 'status',
                                value: category.status === 1 ? 2 : 1,
                                updatememory: 1,
                            })}
                            onClick={this.saveLineField}
                        >
                            <i class={`fas fa-toggle-${category.status === 2 ? 'on' : 'off'}`} />
                            &nbsp;<i class='fas fa-check' /> DealerWeb
                        </span>
                        <span
                            class={`mr-1 badge ${style.pointerCursor} badge-${category.showOnConsumerWeb === 1 ? 'success' : 'danger'}`}
                            // onClick={() => categoryStore.saveField(category.id, `showOnConsumerWeb`, category.showOnConsumerWeb === 1 ? 0 : 1, true)}
                            data-params={JSON.stringify({
                                id: category.id,
                                field: 'showOnConsumerWeb',
                                value: category.showOnConsumerWeb === 1 ? 0 : 1,
                                updatememory: 1,
                            })}
                            onClick={this.saveLineField}
                        >
                            <i class={`fas fa-toggle-${category.showOnConsumerWeb === 1 ? 'on' : 'off'}`} />
                            &nbsp;<i class='fas fa-check' /> ConsumerWeb
                        </span>
                        <span
                            class={`mr-1 badge ${style.pointerCursor} badge-${category.preSale === 1 ? 'success' : 'danger'}`}
                            // onClick={() => categoryStore.saveField(category.id, `preSale`, category.preSale === 1 ? 0 : 1, true)}
                            data-params={JSON.stringify({
                                id: category.id,
                                field: 'preSale',
                                value: category.preSale === 1 ? 0 : 1,
                                updatememory: 1,
                            })}
                            onClick={this.saveLineField}
                        >
                            <i class={`fas fa-toggle-${category.preSale === 1 ? 'on' : 'off'}`} />
                            &nbsp;<i class='fas fa-check' /> PS
                        </span>
                    </small>
                </td>
                <td class='text-right'>
                    <Input
                        id={category.id}
                        className='text-right form-control-sm'
                        isValid={saved[`sort.${category.id}`]}
                        name='sort'
                        value={category.sort}
                        dataParams={JSON.stringify({
                            id: category.id,
                            field: 'sort',
                        })}
                        onInput={this.updateLineField}
                        hideHelp={1}
                    />
                </td>
                <td class='text-right'>
                    <Input
                        id={category.id}
                        className='text-right form-control-sm'
                        isValid={saved[`discount.${category.id}`]}
                        name='discount'
                        value={category.discount}
                        dataParams={JSON.stringify({
                            id: category.id,
                            field: 'discount',
                        })}
                        onInput={this.updateLineField}
                        hideHelp={1}
                    />
                </td>
                <td class='text-right'>
                    {category.count}
                </td>
                <td class='text-right'>
                    {category.countPresale}
                </td>
                <td class='text-right'>
                    <span
                        class={`mr-1 badge ${style.pointerCursor} badge-${category.offline === 1 ? 'success' : 'danger'}`}
                        data-params={JSON.stringify({
                            id: category.id,
                            field: 'offline',
                            value: category.offline === 1 ? 0 : 1,
                            updatememory: 1,
                        })}
                        onClick={this.saveLineField}
                    >
                        &nbsp;<i class={`fas fa-trash${category.offline === 1 ? '-restore' : ''}`} /> {category.offline === 1 ? 'Restore' : 'Delete'}
                    </span>
                </td>
            </tr>
        );
    }
}

@observer
class CategoryTable extends Component {
    render() {
        const { categories, saved, saveField, updateField, categoryStore } = this.props;
        return (
            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                <thead>
                    {categoryStore.sort !== categoryStore.defaultSort && <tr>
                        <th colspan='8'>
                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => categoryStore.resetSort()}>
                                <i class='fas fa-times-circle' /> Reset sort
                            </span>
                        </th>
                    </tr>}
                    <tr>
                        <th style='width: 5%'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('groupno', '')}>
                                Groupno {util.getSortIcon('groupno', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 50%'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('name', '')}>
                                Name {util.getSortIcon('name', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('level', '-')}>
                                Level {util.getSortIcon('level', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('parent', '-')}>
                                Parent {util.getSortIcon('parent', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('status', '')}>
                                Status {util.getSortIcon('status', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 10%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('sort', '')}>
                                Sort {util.getSortIcon('sort', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 10%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('discount', '-')}>
                                Discount {util.getSortIcon('discount', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('count', '-')}>
                                Count {util.getSortIcon('count', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('countPresale', '-')}>
                                Count presale {util.getSortIcon('countPresale', categoryStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-center'>
                            <span class={style.pointerCursor} onClick={() => categoryStore.toggleSort('offline', '-')}>
                                Offline {util.getSortIcon('offline', categoryStore.sort)}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {!categories.length && <tr class={`${style.tableline}`}>
                        <td class='text-center' colspan='9'>
                            <h5>No categories found</h5>
                            Try using the "Show all" button if you are missing some categories.
                        </td>
                    </tr>}
                    {categories && categories.map(category => (
                        <CategoryTableLine
                            category={category}
                            saved={saved}
                            saveField={saveField}
                            updateField={updateField}
                        />
                    ))}
                </tbody>
            </table>
        );
    }
}

const initialState = {
    height: 100,
    loading: false,
    view: {
        brands: false,
        languages: false,
        categories: false,
    },
};

@observer
class CategoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { categoryStore } = this.props.stores;
        categoryStore.list();
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { categoryStore } = this.props.stores;
        const { totalAppend, limit } = categoryStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = categoryStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                categoryStore.updateOffset(offset);
                await categoryStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    updateField = async (id, field, value) => {
        const { categoryStore } = this.props.stores;
        categoryStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { categoryStore } = this.props.stores;
        await categoryStore.saveField(id, field, value);
    }

    saveField = async (id, field, value, updatememory) => {
        const { categoryStore } = this.props.stores;
        categoryStore.saveField(id, field, value, updatememory);
    }

    render() {
        const { loading, height } = this.state;
        const { categoryStore } = this.props.stores;
        const { categories, queryFilter, saved } = categoryStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <CategoryNav {...this.props} />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <CategoryTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {categoryStore.total} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => categoryStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <CategoryTable
                                categories={categories}
                                saved={saved}
                                saveField={this.saveField}
                                updateField={this.updateField}
                                categoryStore={categoryStore}
                            />
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default CategoryList;




// WEBPACK FOOTER //
// ./components/categories/list.js